import SortingSelect from "./SortingSelect";

export default SortingSelect;
